let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("d7nnt")).then(() => parcelRequire('brSVh'));